const productEnrichmentRoutes = [
  {
    path: "/products/enrichments",
    name: "products.enrichments.index",
    component: () =>
      import("@/modules/Products/views/ProductEnrichmentList.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Enriquecimento de Produtos",
      breadcrumb: [
        {
          text: "Enrichments",
          active: true,
        },
      ],
    },
  },
  {
    path: "/products/enrichments/componentes",
    name: "products.enrichments.user-instructions",
    component: () =>
      import(
        "@/modules/Products/views/ProductEnrichmentUserInstructionList.vue"
      ),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Regras de Enriquecimento",
      breadcrumb: [
        {
          text: "Enriquecimento de Produtos",
          to: "/products/enrichments",
        },
        {
          text: "Instruções",
          active: true,
        },
      ],
    },
  },
];

export default productEnrichmentRoutes
